import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { TranslationLoaderFacade } from 'src/app/admin/localization/translation-loader.facade';

@Component({
  selector: 'app-lobby-status-wait-count-tile',
  templateUrl: './lobby-status-wait-count-tile.component.html',
  styleUrls: ['./lobby-status-wait-count-tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LobbyStatusWaitCountTileComponent implements OnInit {

  constructor(private translationLoaderFacade: TranslationLoaderFacade) { }

  ngOnInit() {
  }

}
